import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { CompanyLoginSsoState } from '@pages/login/store/state/company-login-sso.state';
import { LoadSsoStatus } from '@pages/login/store/actions/company-login-sso.actions';

@Injectable({
  providedIn: 'root',
})
export class CompanyLoginSsoFacade {
  private readonly store = inject(Store);

  readonly isSsoEnabled = this.store.selectSignal(CompanyLoginSsoState.isSsoEnabled);
  readonly samlLoginUrl = this.store.selectSignal(CompanyLoginSsoState.samlLoginUrl);

  loadSsoStatus(organizationName: string, trackingId: string): void {
    this.store.dispatch(new LoadSsoStatus(organizationName, trackingId));
  }
}
